import {
  Component, Input, Output, EventEmitter
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ConfirmModalContent } from 'models/modal.model';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  @Input() headingKey!: string;

  @Input() cancel = 'GENERAL.CANCEL';

  @Input() confirm = 'GENERAL.YES';

  @Input() showCancel = true;

  @Input() showConfirm = true;

  @Input() hideCloseIcon = false;

  @Input() content?: ConfirmModalContent[];

  @Output() confirmed = new EventEmitter<boolean>();

  constructor(
    public bsModalRef: BsModalRef
  ) {
    //
  }

  onClickConfirm(): void {
    this.confirmed.emit(true);
    this.bsModalRef.hide();
  }

  onClickCancel(): void {
    this.confirmed.emit(false);
    this.bsModalRef.hide();
  }
}
